import {
  arSD,
  bgBG,
  csCZ,
  daDK,
  deDE,
  elGR,
  esES,
  frFR,
  heIL,
  hiIN,
  hrHR,
  huHU,
  itIT,
  nbNO,
  nlNL,
  plPL,
  ptPT,
  roRO,
  svSE,
  trTR,
  ukUA
} from '@mui/material/locale';
import {
  arSD as dataGridArSd,
  bgBG as dataGridBgBG,
  csCZ as dataGridCsCZ,
  daDK as dataGridDaDK,
  deDE as dataGridDeDE,
  elGR as dataGridElGR,
  esES as dataGridEsES,
  frFR as dataGridFrFR,
  heIL as dataGridHeIL,
  hrHR as dataGridHrHR,
  huHU as dataGridHuHU,
  itIT as dataGridItIT,
  nbNO as dataGridNbNO,
  nlNL as dataGridNlNL,
  plPL as dataGridPlPL,
  ptPT as dataGridPtPT,
  roRO as dataGridRoRO,
  svSE as dataGridSvSE,
  trTR as dataGridTrTR,
  ukUA as dataGridUkUA
} from '@mui/x-data-grid-premium/locales';
import {
  bgBG as datePickersBgBG,
  csCZ as datePickersCsCZ,
  daDK as datePickersDaDK,
  deDE as datePickersDeDE,
  elGR as datePickersElGR,
  esES as datePickersEsES,
  frFR as datePickersFrFR,
  heIL as datePickersHeIL,
  hrHR as datePickersHrHR,
  huHU as datePickersHuHU,
  itIT as datePickersItIT,
  nbNO as datePickersNbNO,
  nlNL as datePickersNlNL,
  plPL as datePickersPlPL,
  ptPT as datePickersPtPT,
  roRO as datePickersRoRO,
  svSE as datePickersSvSE,
  trTR as datePickersTrTR,
  ukUA as datePickersUkUA
} from '@mui/x-date-pickers/locales';
import { defaultsDeep, get } from 'lodash/object';

import { currentLocale } from '../../root/index';

const muiLocaleMap = {
  es: esES,
  'es-CL': esES,
  fr: frFR,
  it: itIT,
  de: deDE,
  hr: hrHR,
  cs: csCZ,
  da: daDK,
  hu: huHU,
  nl: nlNL,
  no: nbNO,
  pl: plPL,
  ro: roRO,
  sv: svSE,
  bg: bgBG,
  el: elGR,
  pt: ptPT,
  hi: hiIN,
  ar: arSD,
  tr: trTR,
  he: heIL,
  uk: ukUA
};

// ED-12379 - No support for Hindi (hi)
const dataGridLocaleMap = {
  es: dataGridEsES,
  'es-CL': dataGridEsES,
  fr: dataGridFrFR,
  it: dataGridItIT,
  de: dataGridDeDE,
  hr: dataGridHrHR,
  cs: dataGridCsCZ,
  da: dataGridDaDK,
  hu: dataGridHuHU,
  nl: dataGridNlNL,
  no: dataGridNbNO,
  pl: dataGridPlPL,
  ro: dataGridRoRO,
  sv: dataGridSvSE,
  bg: dataGridBgBG,
  el: dataGridElGR,
  pt: dataGridPtPT,
  ar: dataGridArSd,
  tr: dataGridTrTR,
  he: dataGridHeIL,
  uk: dataGridUkUA
};

// ED-12379 - No support for Arabic (ar) and Hindi (hi)
const datePickersLocaleMap = {
  es: datePickersEsES,
  'es-CL': datePickersEsES,
  fr: datePickersFrFR,
  it: datePickersItIT,
  de: datePickersDeDE,
  hr: datePickersHrHR,
  cs: datePickersCsCZ,
  da: datePickersDaDK,
  hu: datePickersHuHU,
  nl: datePickersNlNL,
  no: datePickersNbNO,
  pl: datePickersPlPL,
  ro: datePickersRoRO,
  sv: datePickersSvSE,
  bg: datePickersBgBG,
  el: datePickersElGR,
  pt: datePickersPtPT,
  tr: datePickersTrTR,
  he: datePickersHeIL,
  uk: datePickersUkUA
};

export const muiThemeLocales = collectMuiThemeLocales(currentLocale);

export function muiDataGridLocaleText(obj) {
  const locale = dataGridLocaleMap[currentLocale];
  const localeText = get(locale, 'components.MuiDataGrid.defaultProps.localeText');
  if (localeText) {
    return defaultsDeep(obj, localeText);
  }
  return obj;
}

export function muiDatePickersLocaleText(obj) {
  const locale = datePickersLocaleMap[currentLocale];
  const localeText = get(locale, `components.MuiLocalizationProvider.defaultProps.localeText`);

  if (localeText) {
    return defaultsDeep(obj, localeText);
  }
  return obj;
}

function collectMuiThemeLocales(currentLocale) {
  const themeLocales = [];
  const muiLocale = muiLocaleMap[currentLocale];
  const dataGridLocale = dataGridLocaleMap[currentLocale];
  const datePickersLocale = datePickersLocaleMap[currentLocale];
  if (muiLocale) {
    themeLocales.push(muiLocale);
  }
  if (dataGridLocale) {
    themeLocales.push(dataGridLocale);
  }
  if (datePickersLocale) {
    themeLocales.push(datePickersLocale);
  }
  return themeLocales;
}
